function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
var MigrationMain = require('./main');
var STATUS_POLL_MS = 5000;
var SAITO_ARRIVAL_POLL_MS = 1500;
var WAITING_FOR_ISSUANCE = new Set(['inbound_broadcast', 'inbound_confirmed', 'outbound_awaiting', 'outbound_broadcast', 'treasury_submitted', 'treasury_accepted']);
var TERMINAL_STATUSES = new Set(['outbound_confirmed', 'succeeded', 'failed', 'cancelled']);
function statusMessage() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var status = String(data.status || '');
  var amount = data.inbound_amount || data.outbound_amount || '';
  if (status === 'inbound_awaiting') {
    if (Number(data.reserved_until) > 0 && Date.now() >= Number(data.reserved_until)) {
      return 'This reservation has expired. Start a new migration to get a fresh deposit address.';
    }
    return 'Waiting for your deposit...';
  }
  if (status === 'inbound_broadcast' || status === 'inbound_confirmed') {
    return amount ? "Deposit of ".concat(amount, " detected. Waiting for SAITO issuance...") : 'Deposit detected. Waiting for SAITO issuance...';
  }
  if (status === 'outbound_awaiting' || status === 'outbound_broadcast' || status === 'treasury_submitted' || status === 'treasury_accepted') {
    return amount ? "Issuing ".concat(amount, " SAITO to your wallet...") : 'Issuing SAITO to your wallet...';
  }
  if (status === 'outbound_confirmed' || status === 'succeeded') {
    return amount ? "Migration complete. ".concat(amount, " SAITO issued.") : 'Migration complete.';
  }
  if (status === 'failed' || status === 'cancelled') {
    return data.error || 'This migration reservation is no longer active. Start a new migration if needed.';
  }
  return data.error || 'Waiting for your deposit...';
}
module.exports = {
  isMigrationRoute: function isMigrationRoute() {
    var _this$urlpath;
    return ((_this$urlpath = this.urlpath) === null || _this$urlpath === void 0 || (_this$urlpath = _this$urlpath[1]) === null || _this$urlpath === void 0 ? void 0 : _this$urlpath.toLowerCase()) === 'migration';
  },
  requestMigration: function requestMigration(data) {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _this$mixin_peer;
      var peer;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            peer = (_this$mixin_peer = _this.mixin_peer) === null || _this$mixin_peer === void 0 ? void 0 : _this$mixin_peer.publicKey;
            if (peer) {
              _context.n = 1;
              break;
            }
            throw new Error('Migration service is not available');
          case 1:
            return _context.a(2, new Promise(function (resolve, reject) {
              var settled = false;
              var finish = function finish(response) {
                if (settled) {
                  return;
                }
                settled = true;
                clearTimeout(timer);
                if (!(response !== null && response !== void 0 && response.address) || response.error || response.err) {
                  reject(new Error((response === null || response === void 0 ? void 0 : response.error) || (response === null || response === void 0 ? void 0 : response.err) || 'Migration request failed'));
                  return;
                }
                resolve(response);
              };
              var timer = setTimeout(function () {
                return finish({
                  error: 'Migration service timed out'
                });
              }, 30000);
              try {
                _this.app.network.sendRequestAsTransaction('migration request', {
                  publickey: data.publickey,
                  ticker: data.ticker
                }, finish, peer);
              } catch (err) {
                finish({
                  error: (err === null || err === void 0 ? void 0 : err.message) || String(err)
                });
              }
            }));
        }
      }, _callee);
    }))();
  },
  requestMigrationStatus: function requestMigrationStatus(id) {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var _this2$mixin_peer;
      var peer;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            peer = (_this2$mixin_peer = _this2.mixin_peer) === null || _this2$mixin_peer === void 0 ? void 0 : _this2$mixin_peer.publicKey;
            if (!(!peer || !id)) {
              _context2.n = 1;
              break;
            }
            return _context2.a(2, null);
          case 1:
            return _context2.a(2, new Promise(function (resolve) {
              var settled = false;
              var finish = function finish(response) {
                if (settled) {
                  return;
                }
                settled = true;
                clearTimeout(timer);
                resolve(response || null);
              };
              var timer = setTimeout(function () {
                return finish(null);
              }, 15000);
              try {
                _this2.app.network.sendRequestAsTransaction('migration status', {
                  id: id
                }, finish, peer);
              } catch (err) {
                finish(null);
              }
            }));
        }
      }, _callee2);
    }))();
  },
  requestMigrationExtend: function requestMigrationExtend(id) {
    var _this3 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var _this3$mixin_peer;
      var peer;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            peer = (_this3$mixin_peer = _this3.mixin_peer) === null || _this3$mixin_peer === void 0 ? void 0 : _this3$mixin_peer.publicKey;
            if (peer) {
              _context3.n = 1;
              break;
            }
            throw new Error('Migration service is not available');
          case 1:
            if (id) {
              _context3.n = 2;
              break;
            }
            throw new Error('Migration extension requires an id');
          case 2:
            return _context3.a(2, new Promise(function (resolve, reject) {
              var settled = false;
              var finish = function finish(response) {
                if (settled) {
                  return;
                }
                settled = true;
                clearTimeout(timer);
                if (!(response !== null && response !== void 0 && response.address) || response.error || response.err) {
                  reject(new Error((response === null || response === void 0 ? void 0 : response.error) || (response === null || response === void 0 ? void 0 : response.err) || 'Unable to extend the reservation'));
                  return;
                }
                resolve(response);
              };
              var timer = setTimeout(function () {
                return finish({
                  error: 'Migration service timed out'
                });
              }, 30000);
              try {
                _this3.app.network.sendRequestAsTransaction('migration extend', {
                  id: id
                }, finish, peer);
              } catch (err) {
                finish({
                  error: (err === null || err === void 0 ? void 0 : err.message) || String(err)
                });
              }
            }));
        }
      }, _callee3);
    }))();
  },
  clearMigrationStatusPoll: function clearMigrationStatusPoll() {
    clearInterval(this.migration_status_timer);
    this.migration_status_timer = null;
  },
  startMigrationStatusPoll: function startMigrationStatusPoll() {
    var _this$migration_instr,
      _this4 = this;
    this.clearMigrationStatusPoll();
    var id = (_this$migration_instr = this.migration_instructions) === null || _this$migration_instr === void 0 ? void 0 : _this$migration_instr.id;
    if (!id) {
      return;
    }
    this.migration_status_timer = setInterval(function () {
      void _this4.refreshMigrationStatus();
    }, STATUS_POLL_MS);
    void this.refreshMigrationStatus();
  },
  refreshMigrationStatus: function refreshMigrationStatus() {
    var _this5 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      var _this5$migration_inst;
      var id, response;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            id = (_this5$migration_inst = _this5.migration_instructions) === null || _this5$migration_inst === void 0 ? void 0 : _this5$migration_inst.id;
            if (id) {
              _context4.n = 1;
              break;
            }
            return _context4.a(2);
          case 1:
            _context4.n = 2;
            return _this5.requestMigrationStatus(id);
          case 2:
            response = _context4.v;
            if (!(!response || response.error)) {
              _context4.n = 3;
              break;
            }
            return _context4.a(2);
          case 3:
            _this5.applyMigrationStatus(response);
          case 4:
            return _context4.a(2);
        }
      }, _callee4);
    }))();
  },
  expectedMigrationSaitoNolan: function expectedMigrationSaitoNolan() {
    var instructions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.migration_instructions;
    var amount = Number((instructions === null || instructions === void 0 ? void 0 : instructions.outbound_amount) || (instructions === null || instructions === void 0 ? void 0 : instructions.inbound_amount) || 0);
    if (!Number.isFinite(amount) || amount <= 0) {
      return 0n;
    }
    try {
      return this.app.wallet.convertSaitoToNolan(amount);
    } catch (err) {
      return 0n;
    }
  },
  stopMigrationSaitoArrivalWatch: function stopMigrationSaitoArrivalWatch() {
    if (this.migration_saito_arrival_timer) {
      clearInterval(this.migration_saito_arrival_timer);
      this.migration_saito_arrival_timer = null;
    }
    this.migration_saito_arrival_baseline = null;
    this.migration_saito_arrival_expected = null;
    this.migration_saito_arrival_id = null;
  },
  startMigrationSaitoArrivalWatch: function startMigrationSaitoArrivalWatch() {
    var _this6 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      var _this6$migration_inst, _this6$migration_sait, _this6$migration_sait2;
      var instructions, id, status, expected, baseline, _t;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            instructions = _this6.migration_instructions;
            id = instructions === null || instructions === void 0 ? void 0 : instructions.id;
            status = String((instructions === null || instructions === void 0 ? void 0 : instructions.status) || '');
            if (!(!id || !WAITING_FOR_ISSUANCE.has(status) || _this6.migration_saito_arrival_timer)) {
              _context5.n = 1;
              break;
            }
            return _context5.a(2);
          case 1:
            expected = _this6.expectedMigrationSaitoNolan(instructions);
            if (!(expected <= 0n)) {
              _context5.n = 2;
              break;
            }
            return _context5.a(2);
          case 2:
            _this6.migration_saito_arrival_expected = expected;
            _this6.migration_saito_arrival_id = id;
            baseline = 0n;
            _context5.p = 3;
            _context5.n = 4;
            return _this6.app.wallet.getBalance('SAITO');
          case 4:
            baseline = _context5.v;
            _context5.n = 6;
            break;
          case 5:
            _context5.p = 5;
            _t = _context5.v;
            console.error('Migration: unable to read SAITO balance for arrival watch', _t);
            _this6.migration_saito_arrival_expected = null;
            _this6.migration_saito_arrival_id = null;
            return _context5.a(2);
          case 6:
            if (!(_this6.migration_saito_arrival_timer || _this6.migration_saito_arrival_id !== id || !WAITING_FOR_ISSUANCE.has(String(((_this6$migration_inst = _this6.migration_instructions) === null || _this6$migration_inst === void 0 ? void 0 : _this6$migration_inst.status) || '')))) {
              _context5.n = 7;
              break;
            }
            return _context5.a(2);
          case 7:
            _this6.migration_saito_arrival_baseline = baseline;
            _this6.migration_saito_arrival_timer = setInterval(function () {
              void _this6.checkMigrationSaitoArrival();
            }, SAITO_ARRIVAL_POLL_MS);
            (_this6$migration_sait = (_this6$migration_sait2 = _this6.migration_saito_arrival_timer).unref) === null || _this6$migration_sait === void 0 || _this6$migration_sait.call(_this6$migration_sait2);
            void _this6.checkMigrationSaitoArrival();
          case 8:
            return _context5.a(2);
        }
      }, _callee5, null, [[3, 5]]);
    }))();
  },
  checkMigrationSaitoArrival: function checkMigrationSaitoArrival() {
    var _this7 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
      var instructions, balance, _t2;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            instructions = _this7.migration_instructions;
            if (!(!(instructions !== null && instructions !== void 0 && instructions.id) || _this7.migration_saito_arrival_id !== instructions.id || _this7.migration_saito_arrival_baseline == null || _this7.migration_saito_arrival_expected == null || TERMINAL_STATUSES.has(String(instructions.status || '')))) {
              _context6.n = 1;
              break;
            }
            return _context6.a(2);
          case 1:
            balance = 0n;
            _context6.p = 2;
            _context6.n = 3;
            return _this7.app.wallet.getBalance('SAITO');
          case 3:
            balance = _context6.v;
            _context6.n = 5;
            break;
          case 4:
            _context6.p = 4;
            _t2 = _context6.v;
            return _context6.a(2);
          case 5:
            if (balance - _this7.migration_saito_arrival_baseline >= _this7.migration_saito_arrival_expected) {
              _this7.onMigrationSaitoArrived();
            }
          case 6:
            return _context6.a(2);
        }
      }, _callee6, null, [[2, 4]]);
    }))();
  },
  onMigrationSaitoArrived: function onMigrationSaitoArrived() {
    var _this$migration_page;
    var instructions = this.migration_instructions;
    if (!(instructions !== null && instructions !== void 0 && instructions.id) || TERMINAL_STATUSES.has(String(instructions.status || ''))) {
      this.stopMigrationSaitoArrivalWatch();
      return;
    }
    var amount = instructions.outbound_amount || instructions.inbound_amount || '';
    this.stopMigrationSaitoArrivalWatch();
    this.clearMigrationStatusPoll();
    this.migration_instructions = _objectSpread(_objectSpread({}, instructions), {}, {
      status: 'outbound_confirmed',
      ui_status: amount ? "Migration complete. ".concat(amount, " SAITO issued.") : 'Migration complete.'
    });
    (_this$migration_page = this.migration_page) === null || _this$migration_page === void 0 || _this$migration_page.render();
  },
  applyMigrationStatus: function applyMigrationStatus() {
    var _this$migration_instr2, _this$migration_page2;
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!((_this$migration_instr2 = this.migration_instructions) !== null && _this$migration_instr2 !== void 0 && _this$migration_instr2.id) || Number(data.id) !== Number(this.migration_instructions.id)) {
      return;
    }
    var next = _objectSpread(_objectSpread({}, this.migration_instructions), {}, {
      address: data.address || this.migration_instructions.address,
      ticker: data.ticker || this.migration_instructions.ticker,
      reserved_until: data.reserved_until || this.migration_instructions.reserved_until,
      status: data.status || this.migration_instructions.status,
      inbound_amount: data.inbound_amount || '',
      outbound_amount: data.outbound_amount || '',
      ui_status: statusMessage(data)
    });
    this.migration_instructions = next;
    var status = String(next.status || '');
    if (TERMINAL_STATUSES.has(status)) {
      this.clearMigrationStatusPoll();
      this.stopMigrationSaitoArrivalWatch();
    } else if (WAITING_FOR_ISSUANCE.has(status)) {
      void this.startMigrationSaitoArrivalWatch();
    }
    (_this$migration_page2 = this.migration_page) === null || _this$migration_page2 === void 0 || _this$migration_page2.render();
  },
  receiveMigrationInstructions: function receiveMigrationInstructions(data) {
    var _this$migration_page3;
    if (!(data !== null && data !== void 0 && data.address) || !(data !== null && data !== void 0 && data.id)) {
      return;
    }
    this.stopMigrationSaitoArrivalWatch();
    this.migration_instructions = {
      address: data.address,
      ticker: data.ticker,
      id: data.id,
      reserved_until: data.reserved_until,
      status: data.status || 'inbound_awaiting',
      mixin_id: data.mixin_id || '',
      ui_status: statusMessage(data)
    };
    this.startMigrationStatusPoll();
    (_this$migration_page3 = this.migration_page) === null || _this$migration_page3 === void 0 || _this$migration_page3.render();
  },
  receiveMigrationStatusUpdate: function receiveMigrationStatusUpdate(data) {
    if (!this.app.BROWSER || !(data !== null && data !== void 0 && data.id)) {
      return;
    }
    this.applyMigrationStatus(data);
  },
  renderMigrationPage: function renderMigrationPage() {
    var _this8 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
      var _this8$migration_inst;
      var SaitoHeader;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.n) {
          case 0:
            _this8.migration_page = new MigrationMain(_this8.app, _this8);
            if (_this8.migration_header) {
              _context7.n = 1;
              break;
            }
            SaitoHeader = require('../../../../../lib/saito/ui/saito-header/saito-header');
            _this8.migration_header = new SaitoHeader(_this8.app, _this8);
            _context7.n = 1;
            return _this8.migration_header.initialize(_this8.app);
          case 1:
            _context7.n = 2;
            return _this8.migration_header.render();
          case 2:
            _context7.n = 3;
            return _this8.migration_page.render();
          case 3:
            if ((_this8$migration_inst = _this8.migration_instructions) !== null && _this8$migration_inst !== void 0 && _this8$migration_inst.id) {
              _this8.startMigrationStatusPoll();
              if (WAITING_FOR_ISSUANCE.has(String(_this8.migration_instructions.status || ''))) {
                void _this8.startMigrationSaitoArrivalWatch();
              }
            }
          case 4:
            return _context7.a(2);
        }
      }, _callee7);
    }))();
  }
};